import { render } from "./CollectAddUsersToGroup.vue?vue&type=template&id=a00cf506"
import script from "./CollectAddUsersToGroup.vue?vue&type=script&lang=js"
export * from "./CollectAddUsersToGroup.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__